import {
    GET_SIBELGA_UPLOAD_STATUS,
    UPLOAD_SIBELGA_LOAD_CURVES,
} from '../../redux/reducers/constants';
import {
    call,
    getContext,
    put,
    takeLatest,
    takeEvery,
} from 'redux-saga/effects';
import {
    setError,
    setNotif,
    setSibelgaLoadCurvesUploadLoader,
} from '../../redux/actions';
import i18n from 'i18next';
import { errorHandler } from '../common/errorHandler';
import { buildSibelgaErrorMessages } from './sibelgaErrors';

function* uploadSibelgaLoadCurves(action) {
    const { operationId, files } = action;
    yield put(setSibelgaLoadCurvesUploadLoader(true, operationId));

    const uploadGateway = yield getContext('uploadGateway');
    try {
        yield put(
            setNotif({
                message: i18n.t('enoapp.homePage.uploadFiles.uploadAlert'),
                variant: 'warning',
            })
        );
        yield call(uploadGateway.uploadSibelgaLoadCurves, operationId, files);
        yield put(
            setNotif({
                message: i18n.t('enoapp.homePage.uploadFiles.sent'),
            })
        );
    } catch (error) {
        yield errorHandler(error, false);

        const errorsMessages = buildSibelgaErrorMessages(error);

        for (let message of errorsMessages) {
            yield put(
                setError({
                    status: error.response?.status,
                    message,
                    persist: true,
                })
            );
        }
        console.error(error);
    }
    yield put(setSibelgaLoadCurvesUploadLoader(false));
}

function* getSibelgaUploadStatus(action) {
    const { operationId, operationName } = action;

    const uploadGateway = yield getContext('uploadGateway');

    try {
        const event = yield call(
            uploadGateway.getSibelgaUploadEvent,
            operationId
        );
        if (event?.status === 'started') {
            yield put(setSibelgaLoadCurvesUploadLoader(true, operationId));
            yield put(
                setNotif({
                    message: i18n.t(
                        'enoapp.homePage.uploadFiles.pendingUpload',
                        {
                            operationName,
                        }
                    ),
                    variant: 'warning',
                })
            );
        }
    } catch (error) {
        yield errorHandler(error, false);

        const errorsMessages = buildSibelgaErrorMessages(error);

        for (let message of errorsMessages) {
            yield put(
                setError({
                    status: error.response?.status,
                    message,
                    persist: true,
                })
            );
        }

        console.error(error);
        yield put(setSibelgaLoadCurvesUploadLoader(false, operationId));
    }
}

function* uploadSibelgaLoadCurvesSaga() {
    yield takeLatest(UPLOAD_SIBELGA_LOAD_CURVES, uploadSibelgaLoadCurves);
}

function* getSibelgaUploadStatusSaga() {
    yield takeEvery(GET_SIBELGA_UPLOAD_STATUS, getSibelgaUploadStatus);
}

const uploadSagas = [uploadSibelgaLoadCurvesSaga, getSibelgaUploadStatusSaga];

export default uploadSagas;
